/* eslint-disable import/no-mutable-exports */
import httpClient from './http-client';
import mockClassifierService from './classifier.service.mock';

let classifierService;

if (process.env.NODE_ENV === 'development') {
  classifierService = mockClassifierService;
} else {
  classifierService = {
    // params: search, region
    getArCities(params) {
      return httpClient.get('/classifier/arCity', { params });
    },

    // params: search, region
    getArMunicipalities(params) {
      return httpClient.get('/classifier/arMunicipality', { params });
    },

    // params: search, city*
    getArStreets(params) {
      return httpClient.get('/classifier/arStreet', { params });
    },

    // params search
    getCountries(params) {
      return httpClient.get('/classifier/country', { params });
    },

    getEptpSystems() {
      return httpClient.get('/classifier/eptpSystem');
    },

    getLanguages() {
      return httpClient.get('/classifier/language');
    },

    getLicenseActivities(params) {
      return httpClient.get('/classifier/licenceActivity', { params });
    },

    getLicenseClasses(params) {
      return httpClient.get('/classifier/licenceClass', { params });
    },

    getLicenseInstitutions(params) {
      return httpClient.get('/classifier/licenceInstitution', { params });
    },

    getLicenseStatuses(params) {
      return httpClient.get('/classifier/licenceStatus', { params });
    },

    getLicenseTypes(params) {
      return httpClient.get('/classifier/licenceType', { params });
    },

    getMessageCategories() {
      return httpClient.get('/classifier/messageCategory');
    },

    getMessageStatuses() {
      return httpClient.get('/classifier/messageStatus');
    },

    getMessageTypes() {
      return httpClient.get('/classifier/messageType');
    },

    getPositions(params) {
      return httpClient.get('/classifier/position', { params });
    },

    getQualificationTypes(params) {
      return httpClient.get('/classifier/qualificationType', { params });
    },

    getRegions() {
      return httpClient.get('/classifier/region');
    },

    getResourceTypes() {
      return httpClient.get('/classifier/resourceType');
    },

    getWarrantTypes() {
      return httpClient.get('/classifier/warrantType');
    },

    getWarrantStatuses() {
      return httpClient.get('/classifier/warrantStatus');
    },

    getServiceGroups() {
      return httpClient.get('/classifier/serviceGroup');
    },

    getServiceProviders() {
      return httpClient.get('/classifier/serviceProvider');
    },

    getServiceStatuses() {
      return httpClient.get('/classifier/serviceStatus');
    },

    getServiceStatusTypes() {
      return httpClient.get('/classifier/serviceStatusType');
    },

    getRequestTypes() {
      return httpClient.get('/classifier/requestType');
    },
  };
}

export default classifierService;
